/** Składa listę klas CSS, pomijając wartości puste/fałszywe. */
export function cx(...parts: ReadonlyArray<string | false | null | undefined>): string {
  return parts
    .filter((part): part is string => typeof part === 'string' && part.length > 0)
    .join(' ')
}
